import React, { useContext } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import styles from './TicketList.module.css'
import { Link } from 'react-router-dom';
import { AuthContext } from '../../store/auth-context';
import { URL } from '../../constants';


const SessionsList = (props: any) => {

	const authCtx = useContext(AuthContext)

	const list = props.conversations && props.conversations?.length && props.conversations.map((conversation: any, idx: number) => {
		let sessionId = conversation.session_id ? `?session_id=${conversation.session_id}` : ''
		return 	<li key={`conversation-${props.ticketIdx}-${idx}`}>
					<div className={`${styles.sessionDetails} py-4`}>
						<div>{conversation.subject}</div>
						<div>
                            <span className={`${(conversation.session_id && conversation.session_id != 'null') ? styles.chatSession : styles.emailSession}`}>{(conversation.session_id && conversation.session_id != 'null') ? 'Chat' : 'Email'}</span>
                        </div>
						<div>{moment.tz(conversation.date_time, "UTC").format('MMMM DD, YYYY')}</div>
						<div className={conversation.is_processed ? styles.processed : styles.processing}>
							{
								conversation.is_processed ?
									<Link to={`/${authCtx.currentTenant}/${URL.conversation}/${props.threadID}${sessionId}`}>View Conversation</Link> :
									`Processing...`
							}
						</div>
					</div>
				</li>
	})

    return (        
        <div className={styles.sessionTable}>
            <div className={styles.sessionTableHeader}>
                <h6>Conversation Title</h6>
                <h6>Type</h6>
                <h6>Date</h6>
                <h6></h6>
            </div>
            <ul className={styles.sessionListItems}>
                {list}
            </ul>
        </div>
    )
}

export default SessionsList